import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'lib-loading-indicator',
  imports: [MatProgressSpinnerModule],
  host: {
    'data-testid': 'loading-indicator',
  },
  template: `
    <mat-spinner diameter="40"></mat-spinner>
    <p class="mat-body-1">{{ message() }}</p>
  `,
  styles: `
    :host {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 200px;
    }
    p {
      margin-top: 16px;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingIndicatorComponent {
  message = input<string>('Loading...');
}
